import {Component, effect, inject, input, Input, ResourceStatus} from '@angular/core';
import {NotFoundableSessionDiscountDTO} from '../../../../data/dto/session.dto';
import {InputComponent} from '../../common/form/input/input.component';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {LeadResources} from '../../../../resources/lead.resources';
import {SubscriptionService} from '../../../../services/subscription.service';
import {SessionResources} from '../../../../resources/session.resources';
import {toObservable} from '@angular/core/rxjs-interop';
import {NgIf} from '@angular/common';
import {ShowPricePipe} from '../../../../common/pipe/showPrice.pipe';
import {Lead} from '../../../../data/domain/lead';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-sub-discount-code',
  imports: [
    InputComponent,
    ReactiveFormsModule,
    NgIf,
    ShowPricePipe
  ],
  templateUrl: './sub-discount-code.component.html'
})
export class SubDiscountCodeComponent {

  sessionId = input<string>()
  formBuilder = inject(FormBuilder);
  leadResources = inject(LeadResources)
  sessionResources = inject(SessionResources)
  subscriptionService = inject(SubscriptionService)
  discountCodeForm = new FormGroup({
    code: new FormControl(null, {
      validators: [Validators.required],
    }),
  })
  currentDiscount: NotFoundableSessionDiscountDTO

  @Input()
  label: string

  @Input()
  black= false

  @Input()
  set code(code: string) {
    const currentLead = this.leadResources.currentLead.value();
    if (currentLead?.discount?.discountCode != code) {
      this.discountCodeForm.controls.code.setValue(code);
    }
  }

  constructor() {

    let currentLead = this.leadResources.currentLead.value();

    effect(() => {
      const sessionDiscountCodeStatus = this.sessionResources.sessionDiscountCode.status()
      if(sessionDiscountCodeStatus == ResourceStatus.Resolved || sessionDiscountCodeStatus == ResourceStatus.Error) {
        const sessionDiscountCodeDTO = this.sessionResources.sessionDiscountCode.value()

        this.currentDiscount = sessionDiscountCodeDTO

        if (sessionDiscountCodeDTO
          && !sessionDiscountCodeDTO.notFound
          && sessionDiscountCodeDTO.status == "authorized"
          && !(currentLead?.phone && sessionDiscountCodeDTO.deliveredByPhoneNumber == currentLead?.phone)) {

          if (!currentLead) {
            currentLead = new Lead()
            currentLead.sessionId = this.sessionId()
            currentLead.createdAt = DateTime.now().toMillis();
          }
          currentLead.discount = sessionDiscountCodeDTO
          this.leadResources.saveLeadRequest.set(currentLead)
        }
      }
    });


    this.discountCodeForm.valueChanges.subscribe(values => {
      const code = values['code']
      if (this.sessionId() && code) {

        this.sessionResources.sessionDiscountCodeRequest.set({
          code: code,
          sessionId: this.sessionId()
        })
      }
    })
  }
}
